import { get, isNil, isNumber } from 'lodash/fp';
import validators from '../../../utilities/validators';

export const deleteDealerValidator = validators.compose(
    validators.only(values => !isNil(get('confirmValue', values)), validators.matchDeleteConfirmation('confirmValue'))
);

const validator = validators.compose(
    validators.requiredString('dealerInput.displayName'),
    validators.requiredString('dealerInput.legalName.defaultValue'),
    validators.requiredBoolean('dealerInput.isActive'),
    validators.requiredNumber('dealerInput.coe'),
    validators.requiredNumber('dealerInput.ppsr'),
    validators.requiredNumber('dealerInput.estFee'),
    validators.validEmail('dealerInput.contact.email'),

    // When autoplay dealer id or yard id is filled, make sure to fill both
    validators.only(
        values =>
            isNumber(get('dealerInput.integrationDetails.autoplay.dealerId', values)) ||
            isNumber(get('dealerInput.integrationDetails.autoplay.yardId', values)),
        validators.compose(
            validators.requiredNumber('dealerInput.integrationDetails.autoplay.dealerId'),
            validators.requiredNumber('dealerInput.integrationDetails.autoplay.yardId')
        )
    )
);

export default validator;
